module.exports = __webpack_public_path__ + "static/media/instalogo.97eeac1b.png";